var exports = {
  "v": "xa15a2ab7--bdda6a--container--opened",
};

module.exports = exports;
